import axiosInstance from 'src/utils/axios';
import { ProjectListResponse, ProjectQuery, ProjectResponse } from './types.api';

//
//

const BASE_URL = 'projects/v2';

//

export const getProjectByCodeAPI = async (
  params: ProjectQuery,
  options?: any
): Promise<ProjectResponse> => {
  const { projectCode, ...query } = params;

  const response = await axiosInstance.get<ProjectResponse>(`${BASE_URL}/${projectCode}`, {
    params: query,
  });

  if (!response.data) throw new Error('Unexpected API response');

  return response?.data;
};

export const getProjectsApi = async (
  countryCode?: string | null,
  locale?: string,
  filteredOptions?: any,
  currency?: string
): Promise<ProjectListResponse> => {
  let queryArray = [];
  if (locale) queryArray.push('locale=' + locale);
  if (countryCode) queryArray.push('countryCode=' + countryCode);
  if (currency) queryArray.push('currency=' + currency);
  if (filteredOptions?.regions) queryArray.push('regions=' + filteredOptions?.regions);
  if (filteredOptions?.methodCategory)
    queryArray.push('methodCategories=' + filteredOptions?.methodCategory);
  if (filteredOptions?.registry) queryArray.push('registryCodes=' + filteredOptions?.registry);
  if (filteredOptions?.projectIds) {
    filteredOptions.projectIds.forEach((id: string) => queryArray.push('projectIds=' + id));
  }
  if (filteredOptions?.statuses) {
    filteredOptions.statuses.forEach((s: string) => queryArray.push('statuses=' + s));
  }
  if (filteredOptions?.goalNums) {
    filteredOptions.goalNums.forEach((n: string) => queryArray.push('goalNums=' + n));
  }
  // searches all text fields; including highlights
  if (filteredOptions?.searchTerm) queryArray.push('searchTerm=' + filteredOptions?.searchTerm);
  let queryString = queryArray.length ? '?' + queryArray.join('&') : '';

  const response = await axiosInstance.get<ProjectListResponse>(`${BASE_URL}/${queryString}`);

  if (!response.data) throw new Error('Unexpected API response');

  return response?.data;
};
